import React, { useEffect } from 'react';

const Terms = () => {
  useEffect(() => {
    document.title = 'Terms And Conditions';
  }, []);

  return (
    <div className="container py-5">
      <h1 className="mb-3">Terms and Conditions</h1>
      <p className="text-muted">Last updated: December 15, 2025</p>

      <p>
        These Terms and Conditions govern the use of the Seamless Slot website and
        services. By accessing or using the Service, you agree to be bound by these
        Terms. If you do not agree, you must not use the Service.
      </p>

      <h4>1. Interpretation and Definitions</h4>
      <ul>
        <li><strong>Company:</strong> Seamless Slot Limited, 475 Chester Road, Manchester, England, M16 9HF.</li>
        <li><strong>Service:</strong> The Seamless Slot website and appointment booking platform.</li>
        <li><strong>Website:</strong> https://www.seamlessslot.co.uk/</li>
        <li><strong>User:</strong> Any individual accessing or using the Service.</li>
        <li><strong>Business:</strong> Any company or service provider registered on the Service.</li>
        <li><strong>Account:</strong> A registered account created to access the Service.</li>
        <li><strong>Subscription:</strong> A paid plan allowing Businesses to use the Service.</li>
      </ul>

      <h4>2. Scope of the Service</h4>
      <p>
        Seamless Slot provides a technology platform that enables Businesses to offer
        appointment bookings and allows Users to book appointments.
      </p>
      <p>
        Seamless Slot is not a party to the contract between Users and Businesses and
        does not provide the underlying services.
      </p>

      <h4>3. Accounts</h4>
      <ul>
        <li>Maintain confidentiality of account credentials</li>
        <li>All activity conducted through your account</li>
        <li>Ensure information is accurate and up to date</li>
      </ul>

      <h4>4. Subscriptions, Fees, and Payments</h4>
      <ul>
        <li>Recurring subscription fee</li>
        <li>Transaction fee (typically 1%–2%)</li>
        <li>No onboarding fees</li>
      </ul>

      <h4>5. Refunds and Cancellations</h4>
      <p>
        Refunds are handled by the payment provider or the Business according to their
        own policies. Seamless Slot does not issue refunds.
      </p>

      <h4>6. Bookings and Liability</h4>
      <p>
        All services are provided by Businesses. Seamless Slot does not guarantee
        availability, quality, or legality of services.
      </p>

      <h4>7. Marketing and Communications</h4>
      <p>
        Service-related communications may be sent. Marketing messages are only sent
        to users who opt in.
      </p>

      <h4>8. Intellectual Property</h4>
      <p>
        All intellectual property rights in the Service belong to the Company. You may
        not copy, modify, or exploit any part of the Service.
      </p>

      <h4>9. Prohibited Use</h4>
      <ul>
        <li>Fraudulent or unlawful activity</li>
        <li>Circumventing fees</li>
        <li>Scraping or misusing data</li>
        <li>Security interference</li>
      </ul>

      <h4>10. Termination</h4>
      <p>
        The Company may suspend or terminate access at any time for breach of these
        Terms.
      </p>

      <h4>11. Limitation of Liability</h4>
      <p>
        The Service is provided “as is”. Liability is limited to fees paid in the last
        twelve months, to the maximum extent permitted by law.
      </p>

      <h4>12. Governing Law</h4>
      <p>
        These Terms are governed by the laws of England and Wales.
      </p>

      <h4>13. Changes to These Terms</h4>
      <p>
        Terms may be updated at any time. Continued use constitutes acceptance.
      </p>

      <h4>14. Contact Information</h4>
      <p>
        Email: <a href="mailto:info@seamlessslot.co.uk">info@seamlessslot.co.uk</a>
      </p>
    </div>
  );
};

export default Terms;
